import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as assignee from '../assignee'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: assignee.RESOURCE.payload.dimension.partialId,
      partialId: assignee.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description: 'Assignee should be informed of progress towards this outcome',
    isOptional: false,
    name: 'Is Informed',
    partialId: PartialId.Standard.create('is_informed'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
